import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";

export const Wrapper = styled.div`
    display: block;
    position: relative;
    vertical-align: middle;
    @media ${getBreakpoint("down", "md")} {
        white-space: nowrap;
    }
`;

export const Tab = styled.button<{ isActive?: boolean } & SpaceProps>`
    width: auto;
    min-width: 0;
    max-width: 100%;
    height: 42px;
    margin-left: 30px;
    padding: 0 ${theme.space[3]}px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    line-height: 2rem;
    text-align: center;
    text-overflow: ellipsis;
    text-transform: uppercase;
    color: ${theme.colors.dark};
    background-color: transparent;
    border: none;
    border-radius: 0;
    outline: 0;
    opacity: 0.4;
    overflow: hidden;
    ${space};
    &:first-child {
        margin-left: 0;
    }
    span {
        display: inline-block;
        line-height: 2rem;
    }
    &::after {
        display: none;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 1px;
        content: "";
        background-color: ${theme.colors.grey1};
        z-index: 1;
        @media ${getBreakpoint("up", "md")} {
            transform: none;
        }
    }
    ${({ isActive }) =>
        isActive &&
        css`
            position: relative;
            color: ${theme.colors.dark};
            background-color: transparent;
            border-radius: 0;
            opacity: 1;
            &::after {
                display: block;
                bottom: 0;
                height: 2px;
                background-color: ${theme.colors.grey3};
            }
        `};

    html[dir="rtl"] & {
        margin-left: 0;
        margin-right: 30px;
        &:first-child {
            margin-right: 0;
        }
        &::after {
            left: auto;
            right: 0;
        }
    }
`;
